/**
 * @todo Удалить файл с экспериментом
 * @description Данный функционал появился в задаче CD-206852, будет удалён в задаче CD-200835
 */

import { IAppState } from '../../common/state';
import { abUseExperimentsSelector } from '../commonSelectors';

export const NEWBUILDING_MARTECH_TEST_TGB_INSTEAD_PARALLAX_EXPERIMENT = 'newbuilding_martech_test_tgb_instead_parallax';

export function selectIsNewbuildingMartechTestTgbInsteadParallaxGroupParallax(state: IAppState) {
  return (
    abUseExperimentsSelector(state).find(
      e => e.experimentName === NEWBUILDING_MARTECH_TEST_TGB_INSTEAD_PARALLAX_EXPERIMENT,
    )?.groupName === 'parallax'
  );
}
